import { MobilePass } from './mobile-pass'

MobilePass.define('fp-mobile-pass')

declare global {
  interface HTMLElementTagNameMap {
    'fp-mobile-pass': MobilePass;
  }
}
export default MobilePass
